var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlansHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.448,
    height: 17.373,
    viewBox: "0 0 17.448 17.373",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Palns_History",
    "data-name": "Palns History",
    transform: "translate(-425.62 -682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1287",
    "data-name": "Group 1287",
    transform: "translate(426.016 681.706)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_356",
    "data-name": "Rectangle 356",
    width: 17,
    height: 17,
    transform: "translate(-0.016 0.294)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1133",
    "data-name": "Group 1133",
    transform: "translate(2.646 0.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_380",
    "data-name": "Rectangle 380",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M6.586,1.679h0a.568.568,0,0,1,.568.568V4.14a.568.568,0,0,1-.568.568h0a.568.568,0,0,1-.568-.568V2.247A.568.568,0,0,1,6.586,1.679Z",
    transform: "translate(-6.018 -1.679)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M6.665,2.179h0a.147.147,0,0,1,.147.147V4.219a.147.147,0,0,1-.147.147h0a.147.147,0,0,1-.147-.147V2.326A.147.147,0,0,1,6.665,2.179Z",
    transform: "translate(-6.097 -1.758)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_380-2",
    "data-name": "Rectangle 380-2",
    transform: "translate(3.029 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M10.186,1.679h0a.568.568,0,0,1,.568.568V4.14a.568.568,0,0,1-.568.568h0a.568.568,0,0,1-.568-.568V2.247A.568.568,0,0,1,10.186,1.679Z",
    transform: "translate(-9.618 -1.679)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M10.265,2.179h0a.147.147,0,0,1,.147.147V4.219a.147.147,0,0,1-.147.147h0a.147.147,0,0,1-.147-.147V2.326A.147.147,0,0,1,10.265,2.179Z",
    transform: "translate(-9.697 -1.758)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_380-3",
    "data-name": "Rectangle 380-3",
    transform: "translate(6.058 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M13.786,1.679h0a.568.568,0,0,1,.568.568V4.14a.568.568,0,0,1-.568.568h0a.568.568,0,0,1-.568-.568V2.247A.568.568,0,0,1,13.786,1.679Z",
    transform: "translate(-13.218 -1.679)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M13.865,2.179h0a.147.147,0,0,1,.147.147V4.219a.147.147,0,0,1-.147.147h0a.147.147,0,0,1-.147-.147V2.326A.147.147,0,0,1,13.865,2.179Z",
    transform: "translate(-13.297 -1.758)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_382",
    "data-name": "Rectangle 382",
    d: "M5.911,8.68H9.319a.568.568,0,0,1,.568.568h0a.568.568,0,0,1-.568.568H5.911a.568.568,0,0,1-.568-.568h0A.568.568,0,0,1,5.911,8.68Z",
    transform: "translate(-3.265 -2.301)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_383",
    "data-name": "Rectangle 383",
    d: "M5.831,12.021h5.207a.532.532,0,0,1,.488.568h0a.532.532,0,0,1-.488.568H5.831a.533.533,0,0,1-.488-.568h0A.533.533,0,0,1,5.831,12.021Z",
    transform: "translate(-3.265 -2.83)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_384",
    "data-name": "Rectangle 384",
    d: "M5.823,15.361h5.117a.529.529,0,0,1,.48.568h0a.529.529,0,0,1-.48.568H5.823a.53.53,0,0,1-.48-.568h0A.53.53,0,0,1,5.823,15.361Z",
    transform: "translate(-3.265 -3.36)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1284",
    "data-name": "Group 1284",
    transform: "translate(7.951 7.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_474-2",
    "data-name": "Path 474",
    d: "M16.5,9.668a4.175,4.175,0,1,0,4.175,4.175A4.175,4.175,0,0,0,16.5,9.668Z",
    transform: "translate(-12.323 -9.668)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475-2",
    "data-name": "Path 475",
    d: "M17.293,12.862v2h1.368",
    transform: "translate(-13.359 -10.334)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M15.073,9.036V5.046a.841.841,0,0,0-.841-.841H4.134a.842.842,0,0,0-.841.841V17.668a.841.841,0,0,0,.841.841h10.1a.832.832,0,0,0,.793-.6",
    transform: "translate(-2.94 -1.591)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlansHistoryIcon);
export default __webpack_public_path__ + "static/media/plans-history-icon.1a94c24548d98171cb61900eabd33565.svg";
export { ForwardRef as ReactComponent };